/** @format */

import { AnalyticsService } from '@shared/data-access/services';

const QUICK_VIEW_UNSUPPORTED_PAGE_TYPES = new Set(['OrderConfirmation', 'OrderDetails']);

export function reportQuickViewUnavailable(
  analyticsService: AnalyticsService,
  eventName: string,
  pageType: string,
): void {
  if (QUICK_VIEW_UNSUPPORTED_PAGE_TYPES.has(pageType)) {
    return;
  }

  const error =
    'QuickViews Recommendations ATC not visible. window.quickview.openProductQuickView is not defined';
  analyticsService.setErrorId(eventName);
  analyticsService.setErrorMessage(`CART_RECOMMENDATIONS:${error}`);
  analyticsService.triggerAnalyticsEvent(eventName, {
    ErrorMessage: `CART_RECOMMENDATIONS: ${error}`,
    PageType: pageType || 'Cart',
  });
}
